export default {
  hasSideNav(state) {
    return state.hasSideNav;
  },
  bottomNavItemsVisibility(state) {
    return state.bottomNavItemsVisibility;
  }
};
